import React, { useState } from "react"
import "./css/Header.css"
import "./css/Footer.css"
import emailjs from "@emailjs/browser"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import img1065 from "../assets/1065.jpg"
import img0995 from "../assets/0995.jpg"

const Footer = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  function clearAll() {
    setName("")
    setEmail("")
    setMessage("")
  }

  function sendEmail(e) {
    e.preventDefault()
    const templateParams = {
      from_name: name,
      from_email: email,
      from_message: message
    }

    emailjs.send("service_er4ays4", "template_ped1n6o", templateParams, "GO4Kel1r7PXEJaM0e").then(
      result => {
        toast.success("Enquiry sent successfully!")
        clearAll()
      },
      error => {
        console.error("Error sending email:", error.text)
        toast.error("An error occurred while sending your enquiry. Email us at info@jambotreekenya.com")
      }
    )
  }

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">Contact Us</h1>
            <p className="page-subtitle">
              Get in touch with us to discuss your sustainability goals and project requirements
            </p>
          </div>
        </div>
      </section>

      {/* Contact Images Section */}
      <section className="contact-images-section">
        <div className="container">
          <div className="images-gallery">
            <div className="contact-image-container">
              <img src={img1065} alt="Jambo Tree Kenya team" className="contact-image" />
            </div>
            <div className="contact-image-container">
              <img src={img0995} alt="Jambo Tree Kenya operations" className="contact-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2 className="section-title">Send Us a Message</h2>
              <div className="title-underline"></div>
              <p className="form-description">
                Please fill out the form below to send us an email and we will get back to you as soon as possible.
              </p>
            </div>

            <form className="contact-form" onSubmit={sendEmail}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    className="form-input"
                    value={name} 
                    onChange={e => setName(e.target.value)} 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email *</label>
                  <input 
                    type="email" 
                    id="email" 
                    className="form-input"
                    value={email} 
                    onChange={e => setEmail(e.target.value)} 
                    required 
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message *</label>
                <textarea 
                  id="message" 
                  className="form-textarea"
                  rows="6" 
                  value={message} 
                  onChange={e => setMessage(e.target.value)}
                  required
                ></textarea>
              </div>
              
              <div className="form-submit">
                <button type="submit" className="btn btn-primary submit-btn">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="info-header">
            <h2 className="section-title">Contact Information</h2>
            <div className="title-underline"></div>
            <p className="section-description">
              Reach out to us directly using any of the methods below.
            </p>
          </div>

          <div className="contact-info-grid">
            <div className="contact-info-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="contact-text">
                <h4>Address</h4>
                <p>
                  Jambo Tree Farm<br />
                  Loitotok, Kenya
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <div className="contact-text">
                <h4>Phone</h4>
                <p>+254 0714 662 527</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contact-text">
                <h4>Email</h4>
                <p>info@jambotreekenya.com</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M2 12h20"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
              </div>
              <div className="contact-text">
                <h4>Website</h4>
                <p>www.jambotreekenya.com</p>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="business-hours-section">
            <h3>Business Hours</h3>
            <div className="hours-grid">
              <div className="hours-item">
                <span className="day">Monday - Friday:</span>
                <span className="time">8:00 AM - 5:00 PM</span>
              </div>
              <div className="hours-item">
                <span className="day">Saturday:</span>
                <span className="time">9:00 AM - 2:00 PM</span>
              </div>
              <div className="hours-item">
                <span className="day">Sunday:</span>
                <span className="time">Closed</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="contact-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Sustainability Journey?</h2>
            <p>Let's work together to create positive environmental impact and build a sustainable future.</p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">Work With Us</a>
              <a href="/about" className="btn btn-outline">Learn More About Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Footer